import { createWebSocketStore } from 'src/components/#services/helpers';
export const getAllCategories = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_getAll',
    },
});
export const createCategory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_create',
    },
});
export const updateCategory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_update',
    },
});
export const getCategory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_get',
    },
});
export const deleteCategory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_delete',
    },
});
export const getCategoryArticles = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'blog',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'category_getArticles',
    },
});
